/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import PropTypes from "prop-types";
import React, { Component } from "react";
import { AuthorizationService } from "../../../../service/AuthorizationService";
import DealsListingTable from "../../../general/DealsListingTable/DealsListingTable";

type Props = {
    updateState;
    data;
    fetchMore;
    loading;
    deals;
    hasNextPage;
    dealType;
    authorizationService: AuthorizationService;
    pagedListFilterBar;
    keyword;
    disableFilter?;
    sort;
};

type State = { loadingMore };
class DealsListingContainer extends Component<Props, State> {
    lastCursor: any;

    static propTypes = {
        data: PropTypes.object,
        networkStatus: PropTypes.number,
        loading: PropTypes.bool,
        deals: PropTypes.array,
        hasNextPage: PropTypes.bool,
        fetchMore: PropTypes.func,
        refetch: PropTypes.func,
        initialQueryVariables: PropTypes.object,
        authorizationService: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            loadingMore: false
        };
        this.lastCursor = null;
    }

    onClickSort = (column, direction) => {
        this.props.updateState({
            sort: {
                column,
                direction
            }
        });
    };

    onLoadMore = () => {
        const { data, fetchMore } = this.props;

        if (data.deals.edges.length > 0) {
            if (data.deals.pageInfo.end_cursor === this.lastCursor) {
                return null;
            }
        }
        this.lastCursor = data.deals.pageInfo.end_cursor;
        this.setState({ loadingMore: true });

        return fetchMore({
            variables: {
                after: data.deals.pageInfo.end_cursor
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const newEdges = fetchMoreResult.deals.edges;
                const pageInfo = fetchMoreResult.deals.pageInfo;
                const total_count = fetchMoreResult.deals.total_count;

                this.setState({ loadingMore: false });

                return newEdges.length
                    ? {
                          // Put the new comments at the end of the list and update `pageInfo`
                          // so we have the new `endCursor` and `hasNextPage` values
                          deals: {
                              __typename: previousResult.deals.__typename,
                              edges: [
                                  ...previousResult.deals.edges,
                                  ...newEdges
                              ],
                              total_count,
                              pageInfo
                          }
                      }
                    : previousResult;
            }
        });
    };

    render() {
        const {
            loading,
            deals,
            hasNextPage,
            dealType,
            authorizationService,
            pagedListFilterBar,
            keyword
        } = this.props;
        const { loadingMore } = this.state;
        return (
            <div>
                {!this.props.disableFilter && pagedListFilterBar()}
                <DealsListingTable
                    loading={loading}
                    loadingMore={loadingMore}
                    deals={deals}
                    dealType={dealType}
                    hasNextPage={hasNextPage}
                    sort={this.props.sort}
                    onClickSort={this.onClickSort}
                    onLoadMore={this.onLoadMore}
                    authorizationService={authorizationService}
                    renderColumn={{
                        relevance: keyword && keyword.length > 0 ? true : false
                    }}
                />
                <style jsx>{`
                     {
                    }
                `}</style>
            </div>
        );
    }
}

export default DealsListingContainer;
